import React from 'react';
import Desktop from './fund-type-filter-components/desktop';

export default function FundTypeFilter() {
  return (
    <Desktop />
  );
}
